import { Link } from "gatsby"
import React from "react"

const Section = ({ data }) => {
  function contentSection(contentData) {
    return (
      <div className="home-content">
        {contentData.section.title_h2 && <h2>{contentData.section.title_h2}</h2>}
        {contentData.section.description && <p>{contentData.section.description}</p>}
        {contentData.section.call_to_action.title &&
        contentData.section.call_to_action.href ? (
          <Link
            to={contentData.section.call_to_action.href}
            className="btn secondary-btn"
          >
            {contentData.section.call_to_action.title}
          </Link>
        ) : (
          ""
        )}
      </div>
    )
  }

  function imageContent(imageData) {
    return (
      <img src={imageData.section.image.url} alt="section-image" />
    )
  }

  return (
    <div className="home-advisor-section">
      {data.section.image_alignment === "Left"
        ? [imageContent(data), contentSection(data)]
        : [contentSection(data), imageContent(data)]}
    </div>
  )
}

export default Section
